/* eslint-disable react-hooks/rules-of-hooks */
import store from "../store/store";
import { useHelper } from "@sqreem-frontend/sqapp";
import { getCountryCode, getPackage, isCountryXMLAvailable } from "./oneintelligence/OneIntelligenceHelper";
import MainServices from "../services/Main.services";
import ConfigServices from "../services/Config.services";

export const {
    arrayObjectToCSV,
    checkImage,
    createPromise,
    downloadCSV,
    downloadJSON,
    dynamicSort,
    formatNumber,
    generateGUID,
    generateRandom,
    isArray,
    parseBoolean,
    toTitleCase,
    xmlToJson,
} = useHelper();

export const formateDateTime = (d) => {
    const date = new Date(d + "Z");
    return date.toLocaleString('en-US', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true
    });
}

export const isWhitelabeled = () => {
    const { isWhitelabel } = getState("buildTargets");
    return isWhitelabel
}

export const showInsights = () => {
    const packageCode = getPackage()
    if (packageCode) {
        try {
            return ["consumer"].includes(packageCode);
        } catch (error) {
            return true;
        }
    }
    return true
}

export const isAdmin = () => {
    const { username } = MainServices.userDetails()
    if (ConfigServices._adminUsers.includes(username)) return true
}
export const isDev = () => {
    const { mode } = getState("main");
    return (["dev"].includes(mode))
};

export const isFlushCache = () => {
    const { mode } = getState("main");
    return mode === "flushcache"
};

export const isBypass = () => parseBoolean(process.env.REACT_APP_BYPASS);

export const isLocal = () => parseBoolean(process.env.REACT_APP_OI_ISLOCAL);

export const isHasInsightsPermission = () => {
    const { hasAccessToInsightsFeature } = getState("buildTargets");
    return hasAccessToInsightsFeature
}

export const isHasPersonasPermission = () => {
    const { hasAccessToPersonasFeature } = getState("buildTargets");
    return hasAccessToPersonasFeature
}

export const isHasScrapeTopicBrandPermission = () => {
    const { hasAccessToScrapeTopicBrandFeature } = getState("buildTargets");
    return hasAccessToScrapeTopicBrandFeature
}

export const whiteSpaceInternalAccess = () => isDev();

export const capitalize = (str) => String(str.charAt(0)).toUpperCase() + String(str.substr(1)).toLowerCase();

export const updateOngoingApiCallList = (obj, mode = "add") => {
    const { key, value } = obj;

    if (mode === "add") {
        window.sq.oneintel.listOfOngoingApiCalls[key] = value;
    } else if (mode === "remove") {
        delete window.sq.oneintel.listOfOngoingApiCalls[key];
    }
};

export const stopAllOngoingApiCall = () => {
    Object.keys(window.sq.oneintel.listOfOngoingApiCalls).forEach((key) => {
        window.sq.oneintel.listOfOngoingApiCalls[key]();
    });
};

export const cleanString = (text) => {
    let tempString = text;
    tempString = text.replace(/'s/g, " ");
    // eslint-disable-next-line no-useless-escape
    tempString = text.replace(/[.\'\\\/\-\*@]/g, " ");
    // tempString = tempString.replace(/â/g, " ");
    tempString = tempString.replace(/\s+/g, " ");
    return tempString;
};

export const isObject = (item) => {
    return (
        item && typeof item === 'object' && !Array.isArray(item) && item !== null
    );
};

export const handleAPIError = (ResMsg, params, status = 200) => {
    const { url, cls, fnc, isSuccess } = params;
    if (ResMsg && typeof ResMsg === "string") {
        if (ResMsg?.includes("Additional text encountered after finished") || ResMsg?.includes("Unable to cast object of type")) {
            console.error("Error code: ERR-JSONF");
            // window.gs.fSendCloudWatchRecord(url, cls, fnc, {}, 0.1, ResMsg);
            return { error: true, errorMsg: "Something went wrong. (Error code: ERR-JSONF)" };
        }
        if (ResMsg?.toLocaleLowerCase()?.includes("gateway timeout")) {
            console.error("Error code: ERR-GT");
            // window.gs.fSendCloudWatchRecord(url, cls, fnc, {}, 0.1, ResMsg);
            return { error: true, errorMsg: "Something went wrong. (Error code: ERR-GT)" };
        }
    }
    if (ResMsg?.includes("still loading")) {
        return { error: true, errorMsg: "Country is still loading please wait." };
    }
    if (ResMsg?.includes("not loaded")) {
        return { error: true, errorMsg: "Country is not loaded." };
    }
    if (status === 404 && ResMsg?.includes("Could not find")) {
        console.error(ResMsg);
        console.error("Error code: ERR-CNF");
        // window.gs.fSendCloudWatchRecord(url, cls, fnc, {}, 0.1, ResMsg);
        return { error: true, errorMsg: "Something went wrong. (Error code: ERR-CNF)" };
    }
    if (status === 404) {
        return { error: true, errorMsg: "Something went wrong. (Error code: ERR-NR)" };
    }
    if (!isSuccess) {
        return { error: true, errorMsg: ResMsg && typeof ResMsg === "string" ? ResMsg : "Something went wrong." };
    }
    return true;
};

export const deepMergeObjects = (target, source) => {
    let output = Object.assign({}, target);
    if (isObject(target) && isObject(source)) {
        Object.keys(source).forEach((key) => {
            if (isObject(source[key])) {
                if (!(key in target))
                    Object.assign(output, {
                        [key]: source[key],
                    });
                else output[key] = deepMergeObjects(target[key], source[key]);
            } else {
                Object.assign(output, {
                    [key]: source[key],
                });
            }
        });
    }
    return output;
};

export const folderStyle = { fontSize: "15px", marginRight: "2mm", color: "var(--yellow-400)" };

export const accessShowZero = () => {
    const usergroupname = MainServices.getUserGroup();
    return ["dataedit", "dataview", "devsecops"].includes(usergroupname);
};

export const isViewer = () => parseBoolean(process.env.REACT_APP_ISVIEWER)

export const generateUserQueue = async (selectedCountry) => {
    if (!isCountryXMLAvailable(selectedCountry)) return
    const userInfo = MainServices.userDetailsCache
    // const request_queue_name = `oi-legacy-${userInfo.username}-request`
    const response_queue_name = `oi-legacy-${userInfo.username}-response`

    const request_queue = "https://sqs.ap-southeast-1.amazonaws.com/788016873502/savant_central_ecsec2"
    // const request_queue = MainServices.scoreQueueURL(null, null, request_queue_name)
    const response_queue = MainServices.scoreQueueURL(null, null, response_queue_name)

    // await MainServices.createQueue(null, null, request_queue_name, { VisibilityTimeout: "1800" })
    await MainServices.createQueue(null, null, response_queue_name, { VisibilityTimeout: "1800" })

    const startApp = {
        "username": userInfo.username,
        "request_queue": request_queue,
        "response_queue": response_queue,
        "application": window.sq.oneintel.appName,
        "initial_region": getCountryCode("savant", selectedCountry)
    }

    window.sq.oneintel = {
        ...window.sq.oneintel,
        ...startApp
    }

    MainServices.sqsSendMessage("https://sqs.ap-southeast-1.amazonaws.com/788016873502/command_center_startup", JSON.stringify(startApp))
}

export const isObjAllUndefined = (obj = {}) => {
    const temp = Object.keys(obj).reduce((acc, key) => {
        if (obj[key]) acc[key] = obj[key]
        return acc
    }, {})

    return Object.keys(temp).length ? temp : null
}

export const getName = (name, searchedList) => {
    if (!searchedList?.length) {
        return name;
    }
    const regex = new RegExp(`(${searchedList.join("|")})`, "gi");
    return (
        <span>
            {name.split(regex).map((part, index) =>
                regex.test(part) ? (
                    <span key={index} style={{ backgroundColor: "yellow" }}>
                        {part}
                    </span>
                ) : (
                    <span key={index}>{part}</span>
                )
            )}
        </span>
    );
};

const getState = (key) => {
    const state = store.getState();;

    if (key) return state[key];
    return state;
};
export default getState